import styled from 'styled-components';

const StyledTableContainer = styled.div`
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 24px;
  margin-top: 24px;
`;

export {StyledTableContainer};
